var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEditColumns = function SvgEditColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.833 9c3.209 0 5.667-.125 5.667-.278V4.278C12.5 4.125 10.042 4 6.833 4 3.625 4 1 4.125 1 4.278v4.444C1 8.875 3.625 9 6.833 9zm10.692-1.098l-.236-.097-6.71 5.872.236.693v-.596l6.71-5.872zM20.19 4a.799.799 0 00-.518.188l-1.356 1.186 2.778 2.43L22.45 6.62a.59.59 0 000-.914l-1.733-1.517A.785.785 0 0020.19 4zm-2.666 2.068l-8.192 7.168v2.43h2.778l8.191-7.168-2.777-2.43z",
    fill: "#22343B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.167V18.5M6.832 8.167V18.5M12 8.167V18.5m.5.5H1",
    stroke: "#22343B"
  })));
};
export default SvgEditColumns;